import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/auth";
import Login from "@/pages/Login";
import Planner from "@/pages/Planner";
import { Toaster } from "@/components/ui/sonner";

function Protected({ children }) {
  const { operator, checking } = useAuth();
  if (checking) return null;
  if (!operator) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Planner /></Protected>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
